import React from "react";
import { X } from "lucide-react";

const ExpensesModal = ({ isOpen, onClose, expenses }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="expenses-modal-overlay" onClick={onClose} />

      <div className="expenses-modal">
        <div className="expenses-modal-header">
          <h4>All Expenses</h4>
          <X className="modal-close" size={18} onClick={onClose} />
        </div>

        <div className="modal-list">
          {expenses.length === 0 && (
            <p style={{ fontSize: "12px", textAlign: "center" }}>
              No expenses found
            </p>
          )}

          {expenses.map((exp, i) => (
            <div key={i} className="expense-item">
              <div className="expense-top">
                <span className="expense-description">
                  {exp.description}
                </span>
                <span className="expense-amount">
                  ₹{exp.amount.toLocaleString()}
                </span>
              </div>

              <div className="expense-meta">
                <span
                  className={`status approval ${exp.approvalStatus.toLowerCase()}`}
                >
                  {exp.approvalStatus}
                </span>
                <span
                  className={`status payment ${exp.paidStatus.toLowerCase()}`}
                >
                  {exp.paidStatus}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ExpensesModal;
